<template >
  <div style="width: 100%; font-size: 14px;">
    <van-steps
      direction="vertical"
      :active="0"
      active-color="#fea812"
    >
      <van-step
        v-for="(operationLog, index) in orderOperationLog"
        :key="index"
      >
        <div style="line-height: 20px;">{{generateCustomizeString('operator')}} {{ operationLog.operator }} &nbsp;&nbsp;&nbsp; {{ generateCustomizeString('operationType') }} {{ operationLog.operationalAttributes }}</div>
        <div style="line-height: 26px;">{{generateCustomizeString('operationTime')}} {{ operationLog.operatingTime | toLocalTime }}</div>
        <div>{{ operationLog.operationDetails }}</div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import {
  Row,
  Col,
  Uploader,
  Icon,
  Button,
  Cell,
  CellGroup,
  Step,
  Steps
} from 'vant'
// import request from '@/utils/request'

export default {
  name: 'OperationLog',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Step.name]: Step,
    [Steps.name]: Steps
  },
  data() {
    return {
      imageList: [
        // 'https://img.yzcdn.cn/1.jpg'
        'https://img.yzcdn.cn/2.jpg'
      ]
    }
  },
  props: {
    orderOperationLog: {
      type: Array
    }
  },
  methods: {
    generateCustomizeString
  },
  created: function() {
    // Add barcode scan listener and pass the callback function
    // this.RegisterWxJsApi()
  }
}
</script>

<style lang="less" scoped>
</style>
